module.exports = __webpack_public_path__ + "img/dean.8524263d.jpeg";